<template>
  <div class="ekt-sub-menu-bar-item" :class="getCalss" :title="menu.name">
    <div class="menu-icon" v-if="menu.logo_type === 1" :style="{backgroundColor: menu.logo.split(',')[0]}">
      <i :class="['iconfont', menu.logo.split(',')[1]]"></i>
    </div>
    <div class="menu-icon" v-else>
      <img :src="menu.logo" />
    </div>
    <span class="ekt-menu-bar-item-title ellipsis-inline">{{ menu.name }}</span>
  </div>
</template>
<script>

export default {
  name: "main-sub-menu-item",
  props: {
    menu: {
      type: Object,
      default: function () {
        return {};
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getCalss() {
      return `${this.active ? "actived" : ""}`;
    },
  },
  };
</script>
<style lang="less" scoped>
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/menu/subItem/index.vue